export default __webpack_public_path__ + "static/media/LLL Section 4.4fdf714b.png";